import { getWalletBookWallet } from './getWalletBookWallet.js';

const getWalletPrimaryColor = (walletBook, walletKey) => {
    const walletData = getWalletBookWallet(walletBook, walletKey);
    return walletData?.brand?.primaryColor;
};

export { getWalletPrimaryColor };
